import { Tooltip } from '@material-ui/core';
import DoneTwoToneIcon from '@material-ui/icons/DoneTwoTone';
import React, { Component } from 'react';
import { activeStates, getIconByLabel, projectStates, states, transactionStates } from '../../../utils/EnumMapping';

class StatusCell extends Component {

    getStatusMarkerClass() {
        return "statusmarker " + this.props.row.state?.toLowerCase()
    }

    getStatusValueClass() {
        return "status-value " + this.props.row.state?.toLowerCase()
    }

    getStatusIconForActiveStates(row) {
        return getIconByLabel(activeStates, row.stateLabel);
    }

    getStatusIconForStates(row) {

        if ('PAID' !== row.state && row.secondaryState) {
            return <Tooltip title={<><div>Átutalva</div><div> {row.stateLabel}</div></>} ><DoneTwoToneIcon /></Tooltip>
        } else {
            let list = states;
            if (row.rowType === 'BANK') {
                list = transactionStates;
            } else if (row.rowType === 'PROJECT') {
                list = projectStates
            }
            let icon = getIconByLabel(list, row.stateLabel);
            return icon;
        }
    }

    getStatusIcon() {
        const row = this.props.row;
        if (row.rowType === 'CUSTOMER' || row.rowType === 'CATEGORY' || row.rowType === 'TAX_TYPE' || row.rowType === 'EMPLOYEE' || row.rowType === 'RESTRAIN_PARTNER' || row.rowType === 'CAR') {
            return this.getStatusIconForActiveStates(row);
        } else {
            return this.getStatusIconForStates(row);
        }
    }



    render() {
        return (
            <>
                <span className={this.getStatusMarkerClass()}></span>
                <span className={this.getStatusValueClass()}>{this.getStatusIcon()}</span>
            </>
        )
    }
}
export default StatusCell;